<template>
  <div class="dutyStatics" ref="dutyStatics">
    <div :class="getDutyStaticsBarClass(item)" v-bind:key="i" v-for="(item, i) in dutyStaticsList">
      <div class="inlineBlock bar1">
        <div
          :class="{
            'bar-title': true,
            'bar1-title': true,
            'bar1-title-green':
              item.handleState == 2 || item.handleState == 3 ? true : false,
          }"
          :title="
              (item.warnType == 3 || item.warnType == 18 || item.warnType == 1003 || item.warnType == 1004 || item.warnType == 1005)
              ? item.eventName
              : item.warnType == 100
              ? (item.typeName ? item.typeName + '-' + item.warnTypeName : '')
              : item.warnType == 150 || item.warnType == 1014
              ? (item.eventName ? item.eventName : '')
              : (item.typeName ? item.typeName + '-' : '') +
                (item.metric ? item.metric : '') +
                (item.warnType === 1 && item.metric === 'TSP'
                  ? '告警'
                  : item.warnType === 1 && item.metric === 'VDM浓度'
                  ? '告警'
                  : item.warnType === 1
                  ? '超标'
                  : item.warnType === 2
                  ? '超低'
                  : item.warnType === 5
                  ? '道路污染'
                  : item.warnType === 99
                  ? '恒值'
                  : '')
          "
        >
          {{
          (item.warnType == 3 || item.warnType == 18 || item.warnType == 1003 || item.warnType == 1004 || item.warnType == 1005)
          ? item.eventName
          : item.warnType == 11
          ? item.typeName + "_" + item.metric + "三倍超标"
          : item.warnType == 10
          ? item.typeName + "_" + item.metric + "持续超标"
          : item.warnType == 6044
          ?  (item.typeName ? item.typeName + "-" + item.eventName : '')
          : item.warnType == 100
          ? (item.typeName ? item.typeName + "-" + item.warnTypeName : '')
          : item.warnType == 150 || item.warnType == 1014
          ? (item.typeName ? item.eventName : '')
          : (item.typeName ? item.typeName + "-" : "") +
          (item.metric ? item.metric : "") +
          (item.warnType === 1 && item.metric === "TSP"
          ? "告警"
          : item.warnType === 1 && item.metric === "VDM浓度"
          ? "告警"
          : item.warnType === 1
          ? "超标"
          : item.warnType === 2
          ? "超低"
          : item.warnType === 5
          ? "道路污染"
          : item.warnType === 99
          ? "恒值"
          : "")
          }}
        </div>
        <div class="bar-content bar1-content">
          <span
            v-if="item.branchFactory"
            style="
              display: block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            "
            :title="item.branchFactory"
          >{{ item.branchFactory }}</span>
          <span
            style="
              display: block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            "
            :title="item.deviceName"
          >{{ item.deviceName }}</span>
          <span style="display: block">{{ item.eventTime }}</span>
        </div>
      </div>
      <div class="inlineBlock bar2">
        <div
          class="bar-title bar2-title"
          :title="item.warnType === 150 ? '运行时长' : item.warnType === 6044 ? item.eventName : item.metric"
        >{{ item.warnType === 5 ? "清洁指数" : item.warnType === 100 ? '超值次数' : item.warnType === 150 ? '运行时长': item.warnType === 6044 ? item.eventName : item.metric }}</div>
        <div class="bar-content number bar2-content start-wrap" v-if="item.warnType == 5">
          <img src="./img/star.png" alt />
          <img src="./img/star.png" alt v-if="item.riskLevel == 2 || item.handleState == 2" />
          <img src="./img/star.png" alt v-if="item.riskLevel == 3 || item.handleState == 2" />
        </div>
        <div
          class="bar-content number bar2-content cemsData"
          v-else-if="item.warnType == 18"
        >{{ item.cemsBreakdownTag == "D" ? "在线监控(监测)仪器仪表故障" : item.cemsBreakdownTag == "B" ? "在线监控(监测)仪器仪表与数采通讯异常" : (item.cemsBreakdownTag == "VGD" ? "在线监控(监测)仪器仪表与数采通讯异常": '') }}</div>
        <div class="bar-content number bar2-content" v-else>
          <!-- 2022-12-13配合AUR需求新增判断warnType==20或21则展示signalName（信号名）-->
          {{
          item.warnType === 99
          ? item.totalConstantTime
          : item.warnType === 4
          ? item.value
          : item.warnType === 20 || item.warnType === 21
          ? item.signalName
          : item.warnType === 100
          ? item.value && item.value.toFixed(0)
          : item.warnType === 6044
          ? item.value
          : item.value && item.value.toFixed(2)
          }}
          <span>{{ item.warnType === 99 || item.warnType === 4 ? "" : item.unit }}</span>
        </div>
      </div>
      <div class="inlineBlock bar3">
        <div
          :class="{
            'bar-title': true,
            'bar3-title': true,
            green: styleType === 'typeGreen' ? true : false,
          }"
          :style="getColor(item.handleState)"
        >{{ item.handleStateCN }}</div>
        <div
          @click="searchDetail(item)"
          :class="{
            'bar-content': true,
            'bar3-content': true,
            green: styleType === 'typeGreen' ? true : false,
          }"
        >
          <span>查看详情</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {dateFormat} from "utils/tools";
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['matrix', 'x', 'y'],
  inject: ['updateEventData'],
  data() {
    //这里存放数据
    return {
      pageInfo: 'dutyStaticsListTiny.vue',
      computedName: '值守事件统计组件',
      dutyStaticsList: [],
      curTicketNo: '',
      styleType: '',
      timer: null,
      dutyStore: []
    }
  },
  //计算属性 类似于data概念
  computed: {
    getColor() {
      return function (status) {
        let result = {}
        if (status === 0) {
          result = {
            color: '#F5A623'
          }
        } else if (status === 1) {
          result = {
            color: '#F5A623'
          }
        } else if (status === 2) {
          result = {
            color: '#30D594'
          }
        }
        return result
      }
    },
    getDutyStaticsBarClass() {
      return function (item) {
        if (item.workTicketNo === this.curTicketNo) {
          if (bmeConfig.styleType && bmeConfig.styleType === 'typeGreen') {
            return 'dutyStaticsBarGreen sel'
          } else {
            return 'dutyStaticsBar sel'
          }
        } else {
          if (bmeConfig.styleType && bmeConfig.styleType === 'typeGreen') {
            return 'dutyStaticsBarGreen'
          } else {
            return 'dutyStaticsBar'
          }
        }
      }
    }
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = bmeConfig.styleType
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    let w = $(that.$refs.dutyStatics).outerWidth()
    let h = $(that.$refs.dutyStatics).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })
    this.getData()
    //handleState 处理状态 0 已创建  1 处理中  2 已处理  3 已撤销
    //eventTime
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance,
          sourcePage: instance,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    checkStore(list) {
      list.forEach(item => {
        if (
          $.inArray(item.workTicketNo, this.dutyStore) < 0 /*&& item.warnType === 1 &&
          (item.handleState === 0 || item.handleState === 1)*/
        ) {
          this.dutyStore.push(item.workTicketNo)
        } else if (
          $.inArray(item.workTicketNo, this.dutyStore) >= 0 /*&&
          (item.handleState === 2 || item.handleState === 3)*/
        ) {
          this.dutyStore.splice($.inArray(item.workTicketNo, this.dutyStore), 1)
        }
      })

      console.log(this.dutyStore)
      if (this.dutyStore.length > 0) {
        //this.$message.close();
        this.$message({
          type: 'info',
          message: '当前有' + this.dutyStore.length + '条超标告警等待处理!',
          duration: 0,
          showClose: true,
          customClass: 'dutyStore'
        })
      }
    },
    searchDetail(item) {
      setPageActive("闭环管理事件详情-2*3","open",1)
      console.log('item', item)
      this.curTicketNo = item.workTicketNo
      let curTime = new Date().getTime()
      item.curTime = curTime
      this.updateEventData(item)
      this.$forceUpdate()
    },
    async getData() {
      setPageActive("闭环管理事件统计-2*3","open",1)
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      let that = this
      let getListParamPageUrl = CONFIG.requestName + this.$apiOpt.getListParamPage
      this.$apiUtils
        .get(getListParamPageUrl, {
          customerId: this.$store.state.customerId,
          pageNum: 1,
          pageSize: 100
        })
        .then(function (data) {
          //debugger;
          //that.checkStore(data.list);
          data.list = data.list.sort(function (a, b) {
            return that.$moment(b.eventTime) - that.$moment(a.eventTime)
          })
          let tmpList = []
          // tmpList判断连续性
          data.list.forEach((item, n) => {
            if (that.$store.state.customerId == 14) {
              if (item.typeName && (item.typeName.indexOf('CEMS') >= 0 || item.typeName.indexOf('TSP') >= 0)) {
                tmpList.push(item)
              }
            } else {
              tmpList.push(item)
            }
          })
          that.dutyStaticsList = tmpList
          that.dutyStaticsList.forEach(item => {
            if (item.warnType === 4) {
              item.value = that.warnValueFilter(item.value)
            } else if(item.warnType == 6044) {
              item.value = item.value.toFixed(2) + "小时"
            }
            if (that.$store.state.customerId == 46) {
              item.metric = item.metric.replace('VDM', 'TSP')
              item.typeName = item.typeName.replace('VDM', 'TSP')
            }
            item.eventTime = that.$moment(item.eventTime).format('MM-DD HH:mm:ss')
            item.handleStateCN = ''
            if (item.handleState === 0) {
              item.handleStateCN = '已创建'
            } else if (item.handleState === 1) {
              item.handleStateCN = '处理中'
            } else if (item.handleState === 2) {
              item.handleStateCN = '已处理'
            } else if (item.handleState === 3) {
              item.handleStateCN = '已撤销'
            }
          })
          that.$forceUpdate()
          // console.log(that.dutyStaticsList);
          //alert(2222);
        })

      this.timer = setTimeout(function () {
        that.getData()
      }, 60000)
    },
    warnValueFilter(offlineTime) {
      if (offlineTime == null || offlineTime <= 0) {
        return '--'
      }

      if (offlineTime < 60) {
        return offlineTime + '分钟'
      }

      if (offlineTime < 1440) {
        if (offlineTime % 60 == 0) {
          return offlineTime / 60 + '小时'
        } else {
          return parseInt(offlineTime / 60) + '小时' + (offlineTime % 60) + '分钟'
        }
      } else {
        let s
        let d = parseInt(offlineTime / 60 / 24)
        let h = parseInt((offlineTime / 60) % 24)
        let m = offlineTime % 60
        s = d + '天'
        if (h >= 1) {
          s += h + '时'
        }
        if (m > 0) {
          s += m + '分'
        }
        return s
      }
    }
  },
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss">
.dutyStore {
  background: rgba(0, 0, 0, 0.3);
  border: none;
  .el-message__content {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.dutyStatics {
  position: absolute;
  height: 720px;
  width: 100%;
  margin-top: 55px !important;
  padding: 10px 32px 20px 32px !important;
  pointer-events: all;
  overflow: auto;
  .dutyStaticsBar {
    position: relative;
    width: 100%;
    display: flex;
    background: rgba(0, 0, 0, 0.8);
    margin: 10px 0;
    border: 1px solid #8badff;
    .bar1 {
      width: calc(100% - 250px);
    }
    .bar2 {
      width: 130px;
    }
    .bar3 {
      width: 90px;
    }
  }

  .dutyStaticsBarGreen {
    position: relative;
    width: 100%;
    display: flex;
    background: rgba(0, 0, 0, 0);
    margin: 10px 0;
    border: 1px solid #8badff;
    .bar1 {
      width: calc(100% - 250px);
    }
    .bar2 {
      width: 130px;
    }
    .bar3 {
      width: 90px;
    }
  }

  .sel {
    box-shadow: 1px 1px 30px #fff !important;
    background: rgb(0, 0, 0) !important;
    border: 2px solid #fff !important;
  }

  .bar-title {
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .bar-content {
    display: block;
    height: 90px;
    padding: 10px 10px;
  }
  .bar1-title {
    font-family: 'normalFont';
    font-size: 18px;
    color: #ff7373;
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    span {
      float: right;
      color: #c8dde1;
    }
  }

  .bar1-title-green {
    color: #30d594 !important;
  }

  .bar1-content {
    color: #c6c6c6;
    font-family: 'normalFont';
    font-size: 18px;
    padding: 10px 15px;
    border-right: 1px solid #99c0ff;
  }

  .bar2-title {
    font-family: 'normalFont';
    font-size: 18px;
    color: #99c0ff;
    padding: 0px 15px;
    border-right: 1px solid #99c0ff;
    border-bottom: 1px solid #99c0ff;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .bar2-content {
    color: #ffffff;
    font-family: 'normalFont';
    font-size: 26px;
    padding: 15px 5px;
    border-right: 1px solid #99c0ff;
    text-align: center;

    span {
      display: block;
      font-size: 16px;
      line-height: 16px;
      font-family: 'normalFont' !important;
      color: #c6c6c6;
    }
  }
  .cemsData {
    color: white;
    font-family: unset !important;
    font-size: 16px !important;
    padding: 10px 5px;
  }
  .bar3-title {
    color: #c6c6c6;
    font-family: 'normalFont';
    font-size: 20px;
    padding: 10px 5px;
    text-align: center;
    background: linear-gradient(225deg, rgba(108, 151, 255, 0.31) 0%, rgba(58, 116, 255, 0.33) 100%, #0049fa 100%);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    height: 62px;
    width: 120px;
    position: relative;
  }

  .bar3-content {
    color: #c6c6c6;
    font-family: 'normalFont';
    font-size: 20px;
    padding: 15px 15px;
    text-align: center;
    background: linear-gradient(225deg, rgba(108, 151, 255, 0.31) 0%, rgba(58, 116, 255, 0.33) 100%, #0049fa 100%);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    height: 62px;
    width: 120px;
    color: #99f5ff;
    position: relative;
    cursor: pointer;
    span {
      //text-decoration: underline;
    }
  }
  .start-wrap {
    line-height: 50px;
    img {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 10px;
    }
  }
  .green {
    background: #4a90e24f !important;
  }
}
</style>
